var exports = {
  "q": "AppLayout.module__appLayout___aUt1bD",
  "X": "AppLayout.module__appLayoutStandalone___aUt1bD",
};

module.exports = exports;
